module.exports = __webpack_public_path__ + "img/color-palettes-1_en.4363a8d.jpg";